import authVM from './modules/auth';
import gameVM from './modules/game';
import addressVM from './modules/address'

export const transformVM = {
    authVM,
    gameVM,
    addressVM
}
